import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { Link } from '@naf-simba/elements-links';
import * as S from './ThankYou.styles';

const ThankYou = ({ goBack }: { goBack: () => void }) => (
  <div>
    <div>
      <Text variant={TextVariant.ArticleTextHeader} tag="span">
        Tusen takk for ditt spørsmål!
      </Text>
      &nbsp;
      <Text variant={TextVariant.ArticleText} tag="span">
        Vi svarer på spørsmål fortløpende, men dessverre vil ikke alle bli besvart. Følg med i feeden om vi svarer på
        det du lurer på.
      </Text>
    </div>
    <S.ButtonLinkWrapper>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action */}
      <Link onClick={() => goBack()} text="Send inn nytt spørsmål" />
    </S.ButtonLinkWrapper>
  </div>
);

export { ThankYou };
